<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div class="d-flex flex-column p-3">
      <!-- Loading tabla -->
      <div
        class="d-flex justify-content-center w-100"
        style="margin-top: 110px"
        v-if="loadingTable"
      >
        <loading />|
      </div>
      <!-- Botones -->
      <div class="d-flex flex-row flex-wrap justify-content-start mb-2" v-else>
        <div style="position: relative; z-index: 1">
          <div class="d-flex" style="position: absolute">

            <!-- Editar multiples -->
            <editar-multiple-acuerdo-clientes
              :acuerdoClientesArreglo="acuerdoClientesArreglo"
              :data="dataAux"
              :limpiarChecks="limpiarChecks"
              :getListaAcuerdosClientes="getListaAcuerdosClientes"
              :vaciarCliente="vaciarCliente"
              :filtroColdtreatment="filtroColdtreatment"
            />
            

            <!-- Reemplazar -->
            <buscar-reemplazar-acuerdo-clientes-modal
              class="z-index-fixed"
              :data="dataAux"
              :getListaAcuerdosClientes="getListaAcuerdosClientes"
              :vaciarCliente="vaciarCliente"
            />

            <aplicar-margen-comercial-modal
              :data="dataAux"
              :getListaAcuerdosClientes="getListaAcuerdosClientes"
            />
            <!-- Publicar/Despublicar -->
            <Button
              :size="15"
              color="#3A9D28"
              colorText="#ffffff"
              tooltip="Publicar/Despublicar Según Filtros"
              icon="fas fa-eye"
              round
              @click.native="publicarDespublicarSegunFiltro()"
              :width="30"
              class="mt-2 mb-3 mr-2"
              translate
            />

            <!-- Publicar todos -->
            <Button
              :size="15"
              color="#E5801A"
              colorText="#ffffff"
              tooltip="Publicar Todos Según Filtros"
              icon="fas fa-eye"
              @click.native="
                publicarDespublicarAcuerdosClientesByBooleano(true)
              "
              round
              :width="30"
              class="mt-2 mb-3 mr-2"
              translate
            />

            <!-- Despublicar todos -->
            <Button
              :size="15"
              color="#dc3545"
              colorText="#ffffff"
              tooltip="Despublicar Todos Según Filtros"
              icon="fas fa-eye-slash"
              @click.native="
                publicarDespublicarAcuerdosClientesByBooleano(false)
              "
              round
              :width="30"
              class="mt-2 mb-3 mr-2"
              translate
            />
            <!-- Eliminación seleccionado(s) -->
            <Button
              :size="15"
              color="#dc3545"
              colorText="#ffffff"
              tooltip="Eliminar Según Seleccionados"
              icon="fas fa-trash"
              round
              :width="30"
              class="mt-2 mb-3 mr-2"
              @click.native="eliminarSeleccionados()"
              translate
            />

            <!-- Eliminar -->            
            <Button
              :size="15"
              color="#dc3545"
              colorText="#ffffff"
              tooltip="Eliminar Según Filtros"
              icon="fa fa-trash-alt"
              round
              :width="30"
              @click.native="eliminarSegunFiltro()"
              class="mt-2 mb-3 mr-2"
              translate
            />
            
            
            <ver-historial-acuerdo-clientes-base-modal
              :data="dataHistorial"
              :load="thisLoading"
            />
            <editar-simple-acuerdo-cliente
              :dataAux="dataEditSimple"
              :data="data"
              :load="thisLoading"
              :limpiarChecks="limpiarChecks"
              :getListaAcuerdosClientes="getListaAcuerdosClientes"
              :filtroColdtreatment="filtroColdtreatment"
            />

            <filtro-acuerdos-clientes
              :data="data"
              :limpiarChecks="limpiarChecks"
              :dataInicial="dataInicial"
            />
          </div>
        </div>

        <div v-if="loading" class="d-flex justify-content-center w-100" style="margin-top: 110px">
          <loading></loading>
        </div>

        <div v-else class="w-100 text-center">

          <new-data-table
            customHeaders
            v-if="acciones.length > 0"
            :headers="headers"
            :data="dataAux"
            :acciones="acciones"
            :max="10"
            paginacion
            buscar
            idtabla="lista_acuerdos_clientes"
            :seleccionar="obtenerFilaSeleccionada"
            :filaChekeada="obtenerFilaSeleccionada"
            check
            :vaciarArreglo="vaciarCliente"
          />

          <not-found-table v-else class="justify-content-center w-100 pt-5" :text="'No se encontraron registros de acuerdos de clientes'" />

        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Componentes
import NewDataTable from "../../common/NewDataTable";
import Button from "../../common/Button";
import Loading from "../../common/loading";
import FiltroAcuerdosClientes from "../../filtros/lineas/tarifas/FiltroAcuerdosClientes";
import VerHistorialAcuerdoClientesBaseModal from "../../../components/modals/lineas/tarifas/acuerdos_clientes_base/VerHistorialAcuerdoClientesBaseModal.vue";
import EditarSimpleAcuerdoCliente from "../../../components/modals/lineas/tarifas/acuerdos_clientes/EditarSimpleAcuerdoCliente";
import EditarMultipleAcuerdoClientes from "../../../components/modals/lineas/tarifas/acuerdos_clientes/EditarMultipleAcuerdoClientes";
import AplicarMargenComercialModal from "../../modals/lineas/tarifas/acuerdos_clientes/AplicarMargenComercialModal.vue";
import NotFoundTable from "../../../components/common/NotFoundTable";
import BuscarReemplazarAcuerdoClientesModal from "../../modals/lineas/tarifas/acuerdos_clientes/BuscarReemplazarAcuerdoClientesModal";
import VueToastify from "vue-toastify";

import {
  deleteManyAcuerdosCliente,
  publicarDespublicarAcuerdosClientes,
  getAcuerdosClientesBaseByIds,
  listarTariffClientRecords,
  publicarDespublicarAcuerdosClienteBase,
  publicarDespublicarAcuerdosClientesByBooleano,
  getListasAcuerdosBase,
} from "@/constants/lineas";

Vue.use(VueToastify);

export default {
  props: {
    data: { type: Array },
    dataInicial: { type: Array },
    load: { type: Boolean },
    getListaAcuerdosClientes: { type: Function, default: () => {} },
  },
  data() {
    return {
      // Estructura para utilizar dataTable vue
      headers: [
        { title: "Cliente", width: "127px" },
        { title: "Naviera", width: "71px" },
        { title: "Naviera Salida", width: "71px" },
        { title: "POL", width: "70px" },
        { title: "POD", width: "70px" },
        { title: "Desde", width: "158px" },
        { title: "Hasta", width: "158px" },
        { title: "Vigencia", width: "158px" },
        { title: "TT", width: "10px" },
        { title: "Pública (Venta)", width: "158px" },
        { title: "Neta Cte Base", width: "158px" },
        { title: "Margen Com.", width: "158px" },
        { title: "Neta Cte.", width: "158px" },
        { title: "Dcto.", width: "50px" },
        { title: "Unidad", width: "50px" },
        { title: "Producto", width: "158px" },
        { title: "Atmósfera", width: "50px" },
        { title: "Trat. frío", width: "50px" },
        { title: "Dias Libres Origen", width: "10px" },
        { title: "Dias Plug Origen", width: "10px" },
        { title: "Dias Libres Destino", width: "10px" },
        { title: "Dias Plug Destino", width: "10px" },
        { title: "Genset", width: "50px" },
        { title: "Get Out", width: "50px" },
        { title: "Comentarios", width: "300px" },
        { title: "Tipo Contrato", width: "158px" },
        { title: "Contrato - Número", width: "158px" },
        { title: "ID Tariff Line", width: "10px" },
        { title: "Acciones", width: "170px" },
      ],
      acciones: [],
      dataAux: this.data,
      thisLoading: false,
      dataHistorial: [],
      dataEditSimple: [],
      acuerdoClientesArreglo: [],
      filtroColdtreatment: [],
    };
  },
  components: {
    NewDataTable,
    Button,
    Loading,
    NotFoundTable,
    FiltroAcuerdosClientes,
    VerHistorialAcuerdoClientesBaseModal,
    EditarSimpleAcuerdoCliente,
    EditarMultipleAcuerdoClientes,
    AplicarMargenComercialModal,
    BuscarReemplazarAcuerdoClientesModal,
  },
  computed: {
    ...mapState(["loading", "loadingTable", "showAcuerdoClientes"]),
  },
  methods: {
    ...mapActions(["ActionSetLoadingTable"]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasAcuerdosClientes",
      "actionSetDataListarTarifasAcuerdosClientesBase",
      "actionSetVisibleModalEditarSimpleAcuerdoLinea",
      "actionSetVisibleModalVerHistorialClientesBase",
    ]),
    vaciarCliente() {
      this.acuerdoClientesArreglo = [] ;
      // this.data = []
    },
    async getDataListas() {
      const dataListas = await getListasAcuerdosBase();
      this.filtroColdtreatment = dataListas.lista_coldtreatment || [];
    },
    async generarBotonesAcciones() {
      let me = this;

      me.acciones = [];

      await me.dataAux.map((item, index) => {
        const { published } = item.data_complementaria;

        me.acciones.push([
          {
            icon:
              published === 1
                ? "fa fa-eye text-success"
                : "fa fa-eye-slash text-danger",
            title: published === 1 ? "Despublicar" : "Publicar",
            id: index,
          },
          {
            icon: "fa fa-edit",
            title: "Editar",
            id: index,
          },
          {
            icon: "fa fa-search",
            title: "Ver historial",
            id: index,
          },
        ]);
      });

      me.ActionSetLoadingTable(false);
    },
    limpiarChecks() {
      this.acuerdoClientesArreglo = [];
    },
    async publicarDespublicarSegunFiltro() {
      if (this.dataAux.length === 0)
        return this.$vToastify.warning(
          "No hay registros para Publicar/Despublicar.",
          "!Precaución¡"
        );

      const response = await this.$vToastify.prompt({
        body: `¿Desea Publicar/Despublicar ${this.dataAux.length} Acuerdos Clientes?`,
        answers: { Sí: true, No: false },
      });

      if (!response) return;

      const form = { ids: this.dataAux.map((d) => d.data_complementaria.id) };

      this.$vToastify.loader("Actualizando Registros...");

      try {
        await publicarDespublicarAcuerdosClientes(form);
        await this.getListaAcuerdosClientes();

        this.$vToastify.stopLoader();
        this.limpiarChecks();

        this.$vToastify.success(
          "Acuerdo Clientes actualizados correctamente",
          "¡Realizado!"
        );
      } catch (error) {
        this.$vToastify.stopLoader();

        return this.$vToastify.error(
          "Error al actualizar registros, recargue la página y vuelva a intentar",
          "¡Error!"
        );
      }
    },
    async publicarDespublicarAcuerdosClientesByBooleano(published) {

      let textToShow = published ? "Publicar": "Despublicar" ;
      if (this.dataAux.length === 0)
        return this.$vToastify.warning(
          "No hay registros para " + textToShow,
          "!Precaución¡"
        );

      const response = await this.$vToastify.prompt({
        body: `¿Desea ${ textToShow } ${this.dataAux.length} Acuerdos Clientes?`,
        answers: { Si: true, No: false },
      });

      if (!response) return;

      const form = {
        ids: this.dataAux.map( d => d.data_complementaria.id),
        published,
      };

      this.$vToastify.loader("Actualizando Registros...");

      try {
        await publicarDespublicarAcuerdosClientesByBooleano(form);
        await this.getListaAcuerdosClientes();

        this.$vToastify.stopLoader();
        this.limpiarChecks();

        this.$vToastify.success(
          "Acuerdo Clientes actualizados correctamente",
          "¡Realizado!"
        );
      } catch (error) {
        this.$vToastify.stopLoader();

        return this.$vToastify.error(
          "Error al actualizar registros, recargue la página y vuelva a intentar",
          "¡Error!"
        );
      }
    },
    async eliminarSegunFiltro() {
      if (!this.showAcuerdoClientes)
        return this.$vToastify.warning(
          "Se deben filtrar datos para poder Buscar y Reemplazar.",
          "!Precaución¡"
        );

      if (this.dataAux.length === 0)
        return this.$vToastify.warning(
          "No hay registros para eliminar.",
          "!Precaución¡"
        );

      const response = await this.$vToastify.prompt({
        body: `¿Desea eliminar ${this.dataAux.length} Acuerdos Clientes Seleccionados?`,
        answers: { Si: true, No: false },
      });

      if (!response) return;

      const form = { acuerdoClientesArreglo: this.dataAux.map( d => d.data_complementaria.id) };

      this.$vToastify.loader("Eliminando Registros...");

      try {

        let { status, message } = await deleteManyAcuerdosCliente(form);

        if (status === 200) {

          await this.getListaAcuerdosClientes();

          this.$vToastify.stopLoader();

          this.limpiarChecks();

          this.$vToastify.success(message, "Éxito");

        } else {

          this.$vToastify.stopLoader();

          this.$vToastify.error(response.message, "Error");

        }

      } catch (error) {

        this.$vToastify.stopLoader();

        return this.$vToastify.error("Error al eliminar seleccionados, recargue la página y vuelva a intentar", "¡Error!");

      }
    },
    async eliminarSeleccionados() {
      if (this.acuerdoClientesArreglo.length === 0)
        return this.$vToastify.warning(
          "Debe seleccionar registros para eliminar.",
          "!Precaución¡"
        );

      const response = await this.$vToastify.prompt({
        body: `¿Desea eliminar ${this.acuerdoClientesArreglo.length} Acuerdos Clientes Seleccionados?`,
        answers: { Sí: true, No: false },
      });

      if (!response) return;

      const form = { acuerdoClientesArreglo: this.acuerdoClientesArreglo };

      this.$vToastify.loader("Eliminando Registros...");

      try {

        let { status, message } = await deleteManyAcuerdosCliente(form);

        if (status === 200) {

          await this.getListaAcuerdosClientes();

          this.$vToastify.stopLoader();

          this.limpiarChecks();

          this.$vToastify.success(message, "Éxito");

        } else {

          this.$vToastify.stopLoader();

          this.$vToastify.error(response.message, "Error");

        }

      } catch (error) {

        this.$vToastify.stopLoader();

        return this.$vToastify.error("Error al eliminar seleccionados, recargue la página y vuelva a intentar", "¡Error!");

      }
    },
    async obtenerFilaSeleccionada({ accion, id, estado }) {

      if (accion === "Editar") {

        this.thisLoading = true;

        this.actionSetVisibleModalEditarSimpleAcuerdoLinea(true);

        const { data_complementaria } = this.dataAux[id];

        const idAcuerdoCliente = parseInt(data_complementaria.id);

        const { data_table } = await getAcuerdosClientesBaseByIds([
          idAcuerdoCliente
        ]);

        this.dataEditSimple = data_table.map((al) => ({
              id: al.data_complementaria.id,
              cliente_id: {
                id: al.data_complementaria.cliente_id.id,
                name: al.data_complementaria.cliente_id.name
              },
              naviera: {
                id: al.data_complementaria.naviera_id.id,
                name: al.data_complementaria.naviera_id.name
              },
              naviera_salida: al.data[2],
              pod: {
                id: al.data_complementaria.pod.id,
                name: al.data_complementaria.pod.name
              },
              pol: {
                id: al.data_complementaria.pol.id,
                name: al.data_complementaria.pol.name
              },
              margin: al.data_complementaria.margin,
              commercial_margin: al.data_complementaria.commercial_margin,
              neta_cliente: al.data_complementaria.neta_cliente,
              from_date: al.data_complementaria.from_date,
              to_date: al.data_complementaria.to_date,
              transit_time: al.data_complementaria.transit_time,
              neta: al.data_complementaria.neta,
              public_value: al.data_complementaria.public_value,
              vigencia: al.data_complementaria.vigencia,
              container_id: {
                id: parseInt(al.data_complementaria.container_id.id),
                name: al.data_complementaria.container_id.name
              },
              products_category_id: {
                id: parseInt(al.data_complementaria.products_category_id.id),
                name: al.data_complementaria.products_category_id.name
              },
              descuento:
                parseInt(al.data_complementaria.public_value) -
                parseInt(al.data_complementaria.neta),
              atmosphere_id: {
                id: parseInt(al.data_complementaria.atmosphere_id.id) ?? "",
                name: al.data_complementaria.atmosphere_id.name ?? ""
              },
              coldtreatment: al.data_complementaria.coldtreatment && al.data_complementaria.coldtreatment !== "-"
                ? {
                    id: al.data_complementaria.coldtreatment_id || "",
                    name: al.data_complementaria.coldtreatment
                  }
                : { id: "", name: "" },
              free_days_embark: al.data_complementaria.free_days_embark,
              plug_days_embark: al.data_complementaria.plug_days_embark,
              free_days_land: al.data_complementaria.free_days_land,
              plug_days_land: al.data_complementaria.plug_days_land,
              genset: al.data_complementaria.genset === "Si",
              get_out: al.data_complementaria.get_out,
              comment: al.data_complementaria.comment,
              tipo_contrato_id: {
                id: al.data_complementaria.tipo_contrato.id,
                name: al.data_complementaria.tipo_contrato.name
              },
              tariff_contract: al.data_complementaria.id_contrato
            }
          )
        );

        this.thisLoading = false;

      } else if (accion === "Publicar" || accion === "Despublicar") {

        const { data_complementaria } = this.dataAux[id];

        await this.publicarDespublicarAcuerdosClienteBase(data_complementaria);

      } else if (accion === "Ver historial") {

        const { data_complementaria } = this.dataAux[id];

        this.thisLoading = true;

        this.actionSetVisibleModalVerHistorialClientesBase(true);

        try {

          const idTariffClients = parseInt(data_complementaria.id);

          const { data } = await listarTariffClientRecords(idTariffClients);

          this.dataHistorial = data.map((d) => ({
            data: [d.name, d.action, d.fecha]
          }));

          this.thisLoading = false;

        } catch (error) {

          this.thisLoading = false;

          return this.$vToastify.error(
            "Error al listar registros, recargue la página y vuelva a intentar.",
            "¡Error!"
          );

        }
      } else if (accion === "fila_chekeada") {

        const { data_complementaria } = this.dataAux[id];

        estado ? this.acuerdoClientesArreglo.push(data_complementaria.id) : (this.acuerdoClientesArreglo = this.acuerdoClientesArreglo.filter((item, index) => index !== id));

      }
    },
    // exportExcelCustom(){
    //   let data = [];

    //   if( this.data.length > 0 ){

    //     const report_keys = Object.keys( this.data[0].report ) ;

    //     data = this.data.map( ({report}) => {

    //       let objTemp = {} ;

    //       report_keys.forEach( key => objTemp[key] = report[key] );
          
    //       return objTemp ;
    //     });
    //   }
      
    //   const fileName = `Acuerdos Clientes - ${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}`;
    //   const exportType = exportFromJSON.types.xls;

    //   exportFromJSON({ 
    //     data ,
    //     fileName, 
    //     exportType,
    //     withBOM: true	
    //   });
    // },
    async publicarDespublicarAcuerdosClienteBase(data_complementaria) {
      const message = data_complementaria.published
        ? "Despublicar"
        : "Publicar";

      const response = await this.$vToastify.prompt({
        body: `¿Desea ${message} Acuerdo?`,
        answers: { Sí: true, No: false },
      });

      if (!response) return;

      const message_loading = data_complementaria.published
        ? "Despublicando..."
        : "Publicando...";

      const form = { id: data_complementaria.id };

      this.$vToastify.loader(message_loading);

      const message_response = data_complementaria.published
        ? "Despublicado"
        : "Publicado";

      try {
        await publicarDespublicarAcuerdosClienteBase(form);

        this.getListaAcuerdosClientes();
        this.$vToastify.stopLoader();

        this.$vToastify.success(
          `Acuerdo de Cliente Bases ${message_response} correctamente`,
          "¡Realizado!"
        );
      } catch (error) {
        this.$vToastify.stopLoader();

        return this.$vToastify.error(
          `Error al ${message}, recargue la página y vuelva a intentar`,
          "¡Error!"
        );
      }
    },
  },
  created() {
    setTimeout(() => {
      this.generarBotonesAcciones();
      this.getDataListas();
    }, 400);
  },
  watch: {
    data: function (_new) {
      if (_new) {
        this.acuerdoClientesArreglo = [] ;
        this.dataAux = _new;
        this.generarBotonesAcciones();
      }
    },
  },
};
</script>

<style>
  .z-index-fixed {
    z-index: 5 !important;
  }
</style>